import React, { useEffect } from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { HashRouter as Router } from "react-router-dom"
import history from "./utils/history"
import { ConfigProvider } from "antd"
import "moment/locale/zh-cn"
import locale from "antd/es/locale/zh_CN"
import enUS from "antd/es/locale/en_US"
import thTH from "antd/es/locale/th_TH"
import ruRU from "antd/es/locale/ru_RU"
import deDE from "antd/es/locale/de_DE"
import "./styles/index.less"
import {createQQmapScripit} from "@/utils/qqmap.js"
import "./i18n"  // 引入国际化配置

// useEffect(() => {
// //创建腾讯地图script
// 
// },[])
createQQmapScripit()

// 获取当前语言
const currentLang = localStorage.getItem('i18nextLng') || 'zh-CN';
let antdLocale = locale;
if (currentLang === 'en-US') antdLocale = enUS;
if (currentLang === 'th-TH') antdLocale = thTH;
if (currentLang === 'ru-RU') antdLocale = ruRU;
if (currentLang === 'de-DE') antdLocale = deDE;

ReactDOM.render(
    <Router>
        <ConfigProvider locale={antdLocale}>
            <App {...history} />
        </ConfigProvider>
    </Router>,
    document.getElementById("root")
)
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
        registration.unregister()
    })
}
